import { axios } from "utilities/axios";
import { IInteractionDetailsResponse, Route } from "@edgetier/watchtower-types";
import { useQuery, UseQueryOptions } from "react-query";

/**
 * Request the interaction details from the backend.
 * @param url The URL of the interaction.
 * @returns The interaction details.
 */
const getInteractionDetails = async (url: string) => {
    const { data } = await axios.get<IInteractionDetailsResponse>(url);
    return data;
};

/**
 * A query for requesting an interaction's details.
 * @param interactionId The ID of the interaction being requested.
 * @returns
 */
export const useInteractionDetails = (
    interactionId: string,
    configuration: UseQueryOptions<IInteractionDetailsResponse> = {}
) => {
    return useQuery<IInteractionDetailsResponse>(
        [Route.InteractionDetails, interactionId],
        () => getInteractionDetails(Route.InteractionDetails.replace(":interactionId", interactionId)),
        configuration
    );
};
